import React from 'react'

import s from './styles.module.scss'

import { Image } from '../../../atoms/containers/Image/Image'
import IconSvg from '../../../atoms/icons/icon-svg/IconSvg'

export interface IMobileBackBar {
  title?: React.ReactNode
  onGoBack?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  image?: string
  extra?: IExtraMobileBackBar
  styleTitle?: React.CSSProperties
}

interface IExtraMobileBackBar {
  icon: any
  onClick: () => void
}

export function MobileBackBar({
  title,
  onGoBack,
  image,
  extra,
  styleTitle,
}: IMobileBackBar) {
  return (
    <div className={s.container}>
      {onGoBack && (
        <div onClick={onGoBack}>
          <IconSvg.ArrowLeft
            color='black'
            style={{ height: '15px', width: '15px' }}
          />
        </div>
      )}

      {image && (
        <Image
          src={image}
          style={{
            height: 24,
            width: 24,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
          type='cover'
          alt='navbar image'
        />
      )}
      {title && (
        <div className={s.title} style={styleTitle}>
          {title}
        </div>
      )}

      {extra && (
        <div className={s.menuRight} onClick={() => extra.onClick()}>
          {extra.icon}
        </div>
      )}
    </div>
  )
}
